import { chakra, Heading } from '@chakra-ui/react';
import { MouseEvent, ReactNode } from 'react';
import { MdArrowDropDown } from 'react-icons/md';
import {
  MBox,
  MButton,
  MFlex,
  MHStack,
  MIcon,
  MPageHeader,
  MSwitch,
} from '../../../../components/Monetize';

interface UsagePageHeaderProps {
  hideHeader: boolean;
  isExpandedAll: boolean;
  onToggleExpandAll: (event: MouseEvent<HTMLButtonElement>) => void;
  showInactiveSubscriptions: boolean;
  onToggleShowInactive: () => void;
  showToggle: boolean;
  children?: ReactNode;
}

export const UsagePageHeader = ({
  hideHeader,
  isExpandedAll,
  onToggleExpandAll,
  showInactiveSubscriptions,
  onToggleShowInactive,
  showToggle,
  children,
}: UsagePageHeaderProps) => {
  return (
    <MPageHeader
      hideContent={hideHeader}
      renderLeftSection={
        <MFlex alignItems="center">
          <Heading size="lg" color="tPurple.base">
            Usage
          </Heading>
        </MFlex>
      }
    >
      <MHStack gap="4">
        {showToggle && (
          <MHStack gap="2">
            <MSwitch
              isChecked={showInactiveSubscriptions}
              size="sm"
              id="inactive-products"
              onChange={onToggleShowInactive}
            />
            <chakra.label
              htmlFor="inactive-products"
              mb="0"
              fontSize="sm"
              fontWeight={400}
              cursor="pointer"
            >
              Show inactive products
            </chakra.label>
          </MHStack>
        )}
        {children}
        <MBox w={120}>
          <MButton
            variant="tertiary"
            rightIcon={
              <MIcon
                as={MdArrowDropDown}
                w="4"
                h="4"
                transform={isExpandedAll ? 'rotate(180deg)' : undefined}
                transition="all ease 0.3s"
              />
            }
            onClick={onToggleExpandAll}
          >
            {isExpandedAll ? 'Collapse all' : 'Expand all'}
          </MButton>
        </MBox>
      </MHStack>
    </MPageHeader>
  );
};
